/**
 * Renderer for the scheduledDate column.
 *
 * Preserves the series link icon from ScheduledDateCell.jsx.
 */
import React from 'react';
import I18n from '@utils/i18n';
export function InspectionScheduledDateRenderer({ item }) {
    const row = item;
    return (React.createElement("span", null,
        row.scheduledDate,
        '\u00A0',
        row.linkToSeries && (React.createElement("a", { href: row.linkToSeries, className: "qmb-ui-button", title: I18n.t('features.inspections_index.scheduled_date_cell.view_series'), "aria-label": I18n.t('features.inspections_index.scheduled_date_cell.view_series') },
            React.createElement("i", { className: "fa-light fa-rectangle-vertical-history" })))));
}
